import { useTranslations } from 'next-intl';

import { UiKitDrawerBase } from '@/fo/ui/kit/drawer/base';
import { Review, ReviewCard } from '@/fo/ui/review/catalog/base';

import { styles } from './UiReviewDetailBase.styles';

export interface UiReviewDetailBaseProps {
  review?: Review;
  onOpenChange: (open: boolean) => void;
  open?: boolean;
  isLoading?: boolean;
}

export function UiReviewDetailBase({
  review,
  onOpenChange,
  open,
  isLoading
}: UiReviewDetailBaseProps) {
  const t = useTranslations();
  const slots = styles();

  return (
    <>
      <UiKitDrawerBase
        title={t('review.detail.title')}
        open={open && !!review}
        direction="right"
        onOpenChange={onOpenChange}
        contentClassName={slots.base()}
        className={slots.modalWrapper()}
      >
        {isLoading && (
          <div className="flex-center h-full">
            <div className="loading w-20" />
          </div>
        )}
        {!isLoading && review && <ReviewCard review={review} />}
      </UiKitDrawerBase>
    </>
  );
}
